import { render, staticRenderFns } from "./StatusOrderHistory.vue?vue&type=template&id=4dbf4dde&"
import script from "./StatusOrderHistory.vue?vue&type=script&lang=js&"
export * from "./StatusOrderHistory.vue?vue&type=script&lang=js&"
import style0 from "./StatusOrderHistory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports